import React from 'react'

import daysToMonths from '../../../utils/daysToMonths'
import { Charts, DaysToFirstResponse, TransformLine } from '../types'
import { ChartProps } from '../types'
import LineChart from './LineChart'
import LineChartSkeletonLoader from './LineChartSkeletonLoader'
import PlatformChartContainer from './PlatformChartContainer'

const transform: TransformLine<DaysToFirstResponse> = (datum) =>
  datum.map(({ data, ...item }) => ({
    ...item,
    data: data
      .sort((current, next) => current.year - next.year)
      .map(({ daysToFirstResponse, year }) => ({
        x: year,
        y: daysToMonths(daysToFirstResponse ?? 0),
      })),
  }))

const AverageApplicantResponseTime: React.FC<ChartProps> = (props) => (
  <PlatformChartContainer
    chart={Charts.DaysToFirstResponseOverTime}
    exportableConfig={{
      filename: 'average_applicant_response_time',
      getData: (data) => {
        const years = data[0].data.map(({ year }) => year)

        return data.map((item) => {
          const datapoints = years.map((year) =>
            item.data.find(({ year: datumYear }) => year === datumYear)
          )

          return [
            item.id,
            ...datapoints.map((datapoint) =>
              datapoint ? daysToMonths(datapoint.daysToFirstResponse ?? 0).toFixed(1) : ''
            ),
          ]
        })
      },
      getHeader: (data) => data[0].data.map(({ year }) => year),
    }}
    skeleton={LineChartSkeletonLoader}
    title="Average Applicant Response Time"
    {...props}
  >
    {({ data: raw, ...dimensions }) => {
      const data = transform(raw)

      return (
        <LineChart
          {...dimensions}
          axisBottom={{
            legend: 'Rejection Year',
          }}
          axisLeft={{
            legend: 'Months To Response',
          }}
          data={data}
          tooltipFormat="1.1f"
        />
      )
    }}
  </PlatformChartContainer>
)

export default AverageApplicantResponseTime
